import { Swiper, Navigation } from "swiper/js/swiper.esm.js";

Swiper.use([Navigation]);

const sectionSwiperOptions = {
  navigation: {
    nextEl: ".events-slider__button-next",
    prevEl: ".events-slider__button-prev"
  },
  breakpoints: {
    640: {
      slidesPerView: 4.5,
      spaceBetween: 15
    },
    480: {
      slidesPerView: 4.2,
      spaceBetween: 10
    },
    400: {
      slidesPerView: 3.8,
      spaceBetween: 10
    },
    320: {
      slidesPerView: 3.2,
      spaceBetween: 10
    }
  }
};

const categorySwiperOptions = {
  slidesPerView: 3,
  noSwiping: true,
  noSwipingClass: "theme-swiper__slide",
  // spaceBetween: 20,
  navigation: {
    nextEl: ".theme-swiper__button-next",
    prevEl: ".theme-swiper__button-prev"
  },
  breakpoints: {
    1200: {
      slidesPerView: 6.5,
      spaceBetween: 20,
      noSwiping: false
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 20,
      noSwiping: false
    }
  }
};

const aboutPageSwiperOptions = {
  slidesPerView: 1,
  noSwiping: false,
  noSwipingClass: "about-feature__item",
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: "true",
    bulletClass: "about-feature__bullet",
    bulletActiveClass: "about-feature__bullet_active"
  },
  breakpoints: {
    961: {
      slidesPerView: 3,
      noSwiping: true
    },
    641: {
      slidesPerView: 2,
      noSwiping: false
    }
  }
};

const contactsPageSwiperOptions = {
  slidesPerView: 1.5,
  speed: 200,
  spaceBetween: 20,
  breakpoints: {
    1366: {
      slidesPerView: 5,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10
    },
    400: {
      slidesPerView: 1.8,
      spaceBetween: 10
    }
  }
};

export default () => {
  const sectionSwiper = document.querySelector(".events-slider__box");
  if (sectionSwiper) {
    new Swiper(sectionSwiper, sectionSwiperOptions);
  }
  // TODO:
  const categorySwiper = document.querySelector(".theme-swiper");
  if (categorySwiper) {
    new Swiper(categorySwiper, categorySwiperOptions);
  }
  const aboutPageSwiper = document.querySelector(".about-feature__content");
  if (aboutPageSwiper) {
    new Swiper(aboutPageSwiper, aboutPageSwiperOptions);
  }
  const contactsPageSwiper = document.querySelector(".tabs-button__container");
  if (contactsPageSwiper) {
    new Swiper(contactsPageSwiper, contactsPageSwiperOptions);
  }
};
